export default {
  setWorkorderBookingsInFlight: (state, payload) => {
    state.workorderBookingsInFlight = payload?.filter(it => it.startDate && it.endDate);
  },
};
